<div class="flex-container min-w-300 justup-dialog" style="padding: 0!important">
  @if (!metaData() || metaData()?.loading) {
    <ngx-skeleton-loader count="1"
                         [theme]="{'height': '80vh', 'width': '80vh', 'background-color': 'var(--color-on-disabled)'}"/>
  } @else {
    @if (!data.readOnly) {
      <div class="close-btn" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
      </div>
    }
    @switch (contentType()) {
      @case ('application/pdf') {
        <object style="height: 90vh; width: 80vw" [data]="sanitizeUrl" type="application/pdf"></object>
      }
      @case ('image/jpeg') {
        <img style="max-height: 90vh; max-width: 80vw; border-radius: 24px" [src]="file().url" alt="JPEG Image"/>
      }
      @case ('image/png') {
        <img style="max-height: 90vh; max-width: 80vw; border-radius: 24px" [src]="file().url" alt="PNG Image"/>
      }
      @case ('image/gif') {
        <img style="max-height: 90vh; max-width: 80vw; border-radius: 24px" class="image-mask" [src]="file().url" alt="GIF image"/>
      }
      @case ('image/webp') {
        <img style="max-height: 90vh; max-width: 80vw; border-radius: 24px" class="image-mask" [src]="file().url" alt="webp image"/>
      }
      @case ('audio/mpeg') {
        <audio style="width: 100%" controls>
          <source [src]="sanitizeUrl" type="audio/mpeg"/>
          Votre navigateur ne supporte pas la lecture audio.
        </audio>
      }
      @case ('video/mp4') {
        <video style="width: 100%; max-height: 90vh" controls>
          <source [src]="sanitizeUrl" type="video/mp4"/>
          Votre navigateur ne supporte pas la lecture vidéo.
        </video>
      }
      @case ('video/webm') {
        <video style="width: 100%; max-height: 90vh" controls>
          <source [src]="sanitizeUrl" type="video/webm"/>
          Votre navigateur ne supporte pas la lecture vidéo.
        </video>
      }
      @case ('application/zip') {
        <a [href]="file().url" download>Télécharger le fichier ZIP</a>
      }
      @default {
        <a [href]="file().url" download>Télécharger le fichier</a>
      }
    }
  }
</div>
